<template>
  <b-card no-body style="margin-top: 3px">
    <b-card-body class="stock-height">
      <div class="stock-heading d-flex align-items-center">
        <img
          src="@/assets/images/portfolio/NiftyVMI.svg"
          class="stock_img"
          alt
          height="32"
        />
        <span class="card-title stockmarket-align ms-2"
          >Nifty VMI Indicator</span
        >
      </div>
      <BRow
        class="align-items-center flex-wrap custom-padding"
        :class="fontSizeClass"
      >
        <BCol
          md="4"
          cols="4"
          class="d-flex justify-content-start align-items-center"
        >
          <span class="label-text">Nifty:</span>
          <span class="nifty-value ms-2">{{
            niftyVMI?.nifty50IndexValue || "-"
          }}</span>
          <span
            :class="{
              positive: parseFloat(niftyVMI?.oneDayChange) > 0,
              negative: parseFloat(niftyVMI?.oneDayChange) < 0,
            }"
            class="ms-1"
            style="font-size: 10px"
            >{{ niftyVMI?.oneDayChange || "0" }}%</span
          >
        </BCol>
        <BCol
          md="4"
          cols="4"
          class="d-flex justify-content-center align-items-center"
        >
          <span class="pe-label">PE:</span>
          <span class="pe-value ms-2">
            {{ formattedNiftyPE }}
          </span>
        </BCol>
        <BCol
          md="4"
          cols="4"
          class="d-flex justify-content-end align-items-center"
        >
          <span class="label-text">Momentum:</span>
          <span class="momentum-value ms-2">{{
            niftyVMI?.marketMomentum || "-"
          }}</span>
        </BCol>
      </BRow>
      <hr class="separator" />
      <BRow
        class="align-items-start flex-wrap custom-padding d-flex"
        :class="fontSizeClass"
      >
        <BCol
          cols="12"
          md="6"
          class="checkbox-section d-flex flex-column justify-content-start"
        >
          <div class="timeframe-label text-muted">
            {{ investmentPeriodLabel }}
          </div>
          <div
            class="checkbox-container d-flex justify-content-start flex-wrap"
          >
            <div
              class="checkbox-wrapper mb-2 me-lg-1 me-0"
              v-for="id in ['1Yr', '3Yr', '5Yr']"
              :key="id"
            >
              <div
                :id="id"
                @click="updateCheckbox(id)"
                class="checkbox-label"
                :class="{ checked: selectedCheckbox === id }"
              >
                <label :for="id" class="checkbox-label">
                  <img
                    v-if="selectedCheckbox === id"
                    src="@/assets/images/portfolio/ticksquare.svg"
                    alt="Checked Box"
                  />
                  <img
                    v-else
                    src="@/assets/images/portfolio/checksquare.svg"
                    alt="Unchecked Box"
                  />
                </label>
              </div>
              <label :for="id" class="checkbox-text">{{
                checkboxLabel(id)
              }}</label>
            </div>
          </div>
        </BCol>
        <BCol
          cols="12"
          md="6"
          :class="[
            'investment-advice',
            'd-flex',
            'align-items-center',
            'justify-content-end',
            investmentAdviceMarginClass,
          ]"
        >
          <div
            @click="openInvestmentAdviceLink"
            :class="['investment-advice-button', investmentAdviceClass]"
            :style="{ fontSize: investmentAdviceFontSize }"
          >
            {{ displayInvestmentAdvice }}
          </div>
        </BCol>
      </BRow>
    </b-card-body>
  </b-card>
  <SubscriptionExpiredModal ref="expiredModal" />
</template>

<script>
import { mapGetters } from "vuex";
import SubscriptionExpiredModal from "./SubcriptionExpiredModal";

export default {
  name: "StockMarket",
  components: {
    SubscriptionExpiredModal,
  },
  data() {
    return {
      selectedCheckbox: "3Yr",
      baseUrl: process.env.VUE_APP_BASE_URL,
      investmentAdvice: {
        "1Yr": "",
        "3Yr": "",
        "5Yr": "",
      },
    };
  },
  computed: {
    ...mapGetters(["niftyVMI", "subscriptionType"]),
    fontSizeClass() {
      return window.innerWidth <= 767.98 ? "mobile-font-size" : "web-font-size";
    },
    investmentAdviceClass() {
      return this.investmentAdvice[this.selectedCheckbox] ===
        "Bad time to invest"
        ? "bad-time"
        : "good-time";
    },
    investmentPeriodLabel() {
      return window.innerWidth <= 1300
        ? "Investment Period"
        : "Pick Investment Period";
    },
    investmentAdviceFontSize() {
      return window.innerWidth <= 1300 ? "10px" : "12px";
    },
    formattedNiftyPE() {
      const niftyPE = Number(this.niftyVMI?.niftyPE) || 0;
      return window.innerWidth <= 420 ? niftyPE.toFixed(1) : niftyPE.toFixed(2);
    },
    investmentAdviceMarginClass() {
      return window.innerWidth <= 1300 ? "mt-2" : "mt-2";
    },
    displayInvestmentAdvice() {
      return this.investmentAdvice[this.selectedCheckbox];
    },
  },
  methods: {
    updateCheckbox(id) {
      this.selectedCheckbox = id;
    },
    processniftyVMIData(data) {
      try {
        if (data && Object.keys(data).length > 0) {
          this.niftyVMI.niftyPE = data.niftyPE;
          this.niftyVMI.nifty50IndexValue = Math.round(data.nifty50IndexValue);
          this.niftyVMI.oneDayChange = data.oneDayChange;
          this.niftyVMI.marketMomentum = data.marketMomentum;
          this.investmentAdvice["1Yr"] = data["1yr"];
          this.investmentAdvice["3Yr"] = data["3yr"];
          this.investmentAdvice["5Yr"] = data["5yr"];
        }
      } catch (error) {
        console.error("Error processing data:", error.message);
      }
    },
    checkboxLabel(id) {
      if (id === "3Yr") {
        return "3 Y";
      }
      return id.replace("Yr", " Y");
    },
    showModal() {
      this.$refs.expiredModal.showModal();
    },
    renewSubscription() {
      window.location.href = `${this.baseUrl}/prime-pricing/`;
    },
    openInvestmentAdviceLink() {
      if (this.subscriptionType != "sub-expired") {
        window.open(`${this.baseUrl}/nifty-vmi-market-mood/`, "_blank");
      } else {
        window.open(`${this.baseUrl}/prime-pricing/`, "_blank");
      }
    },
  },
  watch: {
    niftyVMI: {
      handler(newValue) {
        this.processniftyVMIData(newValue);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.stock-height {
  background: #e9f4ff;
  border-radius: 5px;
  position: relative;
  padding: 0 8px 0 8px;
}

.stock-heading {
  padding: 4px 10px;
}

.b-card-body {
  padding: 0;
}

.separator {
  margin: 3px 0;
  border-top: 2px solid #000;
}

.nifty-value,
.pe-value,
.momentum-value {
  font-weight: 700;
}

.stock_img {
  height: 35px;
  width: 30px;
}

.checkbox-text {
  margin-left: 5px;
}

.stockmarket-align {
  font-weight: 500;
  position: absolute;
  left: 46px;
  top: 10px;
}

.custom-padding {
  padding-left: 15px;
  padding-right: 15px;
}

.web-font-size {
  font-size: 14px;
}

.mobile-font-size {
  font-size: 12px;
}

.investment-advice-button {
  padding: 8px 16px;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  max-width: 200px;
}

.good-time {
  background-color: #1fd19f;
  color: #ffffff;
}

.bad-time {
  background-color: #dd2e44;
  color: #ffffff;
}

.subscribe-time {
  background-color: #01a2d9;
  color: #ffffff;
}

.pe-label {
  margin-left: 5px;
}

.checkbox-section,
.investment-advice {
  flex: 1;
}

.checkbox-container {
  display: flex;
  justify-content: start;
  flex-wrap: nowrap;
  margin: 0;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
}

.investment-advice {
  margin-left: 10px;
}

.timeframe-label {
  font-weight: 500;
}

.positive {
  color: green;
}

.negative {
  color: red;
}
</style>
